import { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Grid,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { put } from "src/utils/networkUtils";
import { getUserPermissions } from "src/utils/permissionsUtils";

export default function MegaspinDialog(props) {
  const [megaspin, setMegaspin] = useState(props.megaspin);
  const [loading, setLoading] = useState(false);
  const { isViewer } = getUserPermissions();

  useEffect(() => {
    if (props?.megaspin) {
      setLoading(false);
      setMegaspin(props.megaspin);
    }
  }, [props.megaspin]);

  const handleChangePossibility = (index, value) => {
    const newPossibilities = [...megaspin.possibilities];
    newPossibilities[index] = value;
    setMegaspin((prevState) => ({
      ...prevState,
      possibilities: newPossibilities,
    }));
  };
  const onSuccess = () => {
    setLoading(true);
    put(`/admin/megaspins/${megaspin.megaspinId}`, {
      startAmount: megaspin.startAmount,
      possibilities: megaspin.possibilities,
    }).then(function () {
      props.onSuccessHandler();
      setLoading(false);
    });
  };
  const onCancel = () => {
    props.onClose();
  };

  return (
    <>
      <Dialog
        open={props.open}
        onClose={() => {}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">Edit Megaspin</DialogTitle>
        <DialogContent>
          {megaspin === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container>
              <Grid item xs={12} sx={{ m: 0, p: 1, mb: 4 }}>
                <TextField
                  id="Gold"
                  label="Start Amount"
                  fullWidth
                  value={megaspin.startAmount}
                  variant="standard"
                  onChange={(event) =>
                    setMegaspin((prevState) => ({
                      ...prevState,
                      startAmount: event.target.value,
                    }))
                  }
                  type="number"
                />
              </Grid>
              {megaspin.possibilities.map((item, index) => (
                <Grid item xs={1} sx={{ m: 0, p: 1 }} key={index}>
                  <TextField
                    id={item}
                    label={`Day ${index + 1}`}
                    fullWidth
                    value={item}
                    variant="standard"
                    onChange={(event) =>
                      handleChangePossibility(index, event.target.value)
                    }
                    type="number"
                    InputProps={{
                      inputProps: {
                        min: 0,
                        max: 100,
                      },
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onCancel()}>Cancel</Button>
          {!isViewer && (
            <Button onClick={() => onSuccess()} autoFocus disabled={false}>
              Edit
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
}
